// Which of the Actions panel's tools can do anything right now. Several of
// them work on one route — the selected one — so with nothing selected (the
// whole-trail overview) they'd silently do nothing, or worse: "Add point by
// coordinate" would start a stray new route. Those are offered only when they
// have something to work on.

interface RouteLike {
  markers?: unknown[];
  lineStrings?: unknown[];
}

export interface RouteToolState {
  activeRouteKey: string | null | undefined;
  routes: { [routeKey: string]: RouteLike };
  /** An area selection is in progress — its menu has to stay reachable to cancel it. */
  isAreaSelecting?: boolean;
}

export interface RouteToolAvailability {
  /** Adds a point to the selected route; on an empty plan, starts the first one. */
  addPointByCoordinate: boolean;
  /** Spaces control points along the selected route's line. */
  addControlPoints: boolean;
  /** Admin: re-draws the selected route along the path network. */
  mapMatch: boolean;
  /** Remove all / select area — both act on the selected route's control points. */
  manageControlPoints: boolean;
}

export function routeToolAvailability(state: RouteToolState): RouteToolAvailability {
  const active = state.activeRouteKey ? state.routes[state.activeRouteKey] : null;
  const activeHasLine = !!active && (active.lineStrings?.length ?? 0) > 0;
  const planIsEmpty = !Object.values(state.routes).some(route => (route.markers?.length ?? 0) > 0);
  return {
    addPointByCoordinate: !!active || planIsEmpty,
    addControlPoints: activeHasLine,
    mapMatch: activeHasLine,
    manageControlPoints: !!active || !!state.isAreaSelecting,
  };
}
